import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { AlertComponent } from './alert.component';


@Injectable({ providedIn: 'root' })
export class AlertService {
    durationInSeconds = 5;
    
    
    constructor(private snackbar : MatSnackBar) {
       
    }

    success(message: string) {
        this.snackbar.openFromComponent(AlertComponent, {
            duration: this.durationInSeconds * 1000,
            data:{text:message,type:"success"}
            });
    }

    error(message: string) {
        this.snackbar.openFromComponent(AlertComponent, {
            duration: this.durationInSeconds * 1000,
            data:{text:message,type:"error"}
            });
    }

    info(message: string) {
        this.snackbar.openFromComponent(AlertComponent, {
            duration: this.durationInSeconds * 1000,
            data:{text:message,type:"info"}
            });
    }

    
}